module.exports = __webpack_public_path__ + "static/media/ticket.b77f6e08.png";